import React, { useEffect, useState } from "react";
import styles from "../styles/components/LoraImagesGrid.module.css";
import common from "../styles/Common.module.css";
import useApi from "../hooks/useApi";
import Loading from "./Loading";
import { useDispatch, useSelector } from "react-redux";
import { deleteImage, startLoraImagePolling } from "../reducers/imagesSlice";
import { getImages } from "../reducers/imagesSlice";
import DeleteButton from "./DeleteButton";

const LoraImagesGrid = ({ id, index, onLoraImageselected }) => {
	const {get, post} = useApi();
	const dispatch = useDispatch();

	const images = useSelector((state) => state.images.items);
   	const status = useSelector((state) => state.images.status);
  
	const [selectedImage, setSelectedImage] = useState(null);

	 useEffect(() => {
		if (status === "idle") {
		  dispatch(getImages({get, generator_id: id, variant_index: index}));
		}
	  }, [status, dispatch, get, id, index]);
	

	for(let i=0; i<images.length; i++){
		const image = images[i];
		// console.log(image.finished)
		if(!image.finished){
			dispatch(startLoraImagePolling({ id: image.id, generator_id: id, variant_index: index, get }));
		}
	}

	  const handleDelete = async (id) => {
		await post(`/webapp/images/delete/${id}/`);
		dispatch(deleteImage(id));
	  };
  
	return (
		<>
			{selectedImage === null &&
				<div className={styles.loraGrid}>
					
					{ images.map( (image) => 
						
						<div key={"image"+image.id} className={styles.loraImageItem}>
							{image.success &&
								// eslint-disable-next-line jsx-a11y/alt-text
								<img className={styles.loraImage} src={image.image} onClick={() => {
									setSelectedImage(image);
									if(onLoraImageselected !== null) onLoraImageselected(image);
								}}/>
							}
							{!image.success && !image.finished &&
								<Loading messageIndex={3} />
							}
							{!image.success && !image.processing && image.finished &&
								<Loading messageIndex={4} />
							}
							<DeleteButton className={styles.deleteButton} onDelete={()=>handleDelete(image.id)} />
						</div>
					)}
				</div>
			}
			{selectedImage !== null &&
			<div className={styles.singleImageContainer}>
				<button className={common.closeButton} onClick={()=>setSelectedImage(null)}>X</button>
				<img className={styles.selectedImage} src={selectedImage.image} />
			</div>
			}
			
		</>
  );
};

export default LoraImagesGrid;
